import axios from "axios";

export const StandaloneService = () => {

    const verifyUpdate = async () => {
        return await axios.get(`${process.env.REACT_APP_API_URL}v1/standalone/checkForUpdate?version=${process.env.REACT_APP_VERSION}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        });
    };

    return {
        verifyUpdate
    }
};